export default "__VITE_IMAGE_ASSET__d48938a9__";